import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const ClientDataNavUI = ({ context, account, page }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI label='Collection Status' to={`/su/accounts/${account.accountId}/dataCollection`} active={page === 'dataCollection'} />
      <TabLinkUI label='MCA' to={`/su/accounts/${account.accountId}/mca`} active={page === 'mca'} />
      <TabLinkUI label='GST' to={`/su/accounts/${account.accountId}/gst`} active={page === 'gst'} />
      <TabLinkUI label='ITR' to={`/su/accounts/${account.accountId}/itr`} active={page === 'itr'} />
      <TabLinkUI label='Bank' to={`/su/accounts/${account.accountId}/clienTxns`} active={page === 'bank'} />
      <TabLinkUI label='Calculations' to={`/su/accounts/${account.accountId}/calculations`} active={page === 'calculations'} />
      <TabLinkUI label='Credit Report' to={`/su/accounts/${account.accountId}/creditReport`} active={page === 'creditReport'} />
      <TabLinkUI label='Chat Files' to={`/su/accounts/${account.accountId}/chatFiles`} active={page === 'chatFiles'} />
    </div>
    <div className='g_m_top_50' />
  </div>

export default ClientDataNavUI
